import React from "react";
import {Dropdown, MenuProps, Popover} from "antd";
import {InfoCircleTwoTone} from "@ant-design/icons";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import {setDataset} from "../cohortBuilderSlice";
import {selectResources} from "../../../actions/userSlice";
import {datasets} from "../../../components/cohort-queries/ListQueries";
import {CohortDataset, Query} from "../../HealthcareUsageReport/types/CohortQuery";
import styles from './DatasetPicker.module.scss'
import _ from "lodash";
import {COHORT_BUILDER_DATASETS, permittedChoices} from "./DatasetPickerUtil";

export const DatasetPicker = ({query} : {query: Query}) => {
    const dispatch = useAppDispatch()
    const resources = useAppSelector(selectResources)
    const options = permittedChoices(datasets(resources))

    const handleMenuClick: MenuProps['onClick'] = (e) => {
        dispatch(setDataset({queryId: query.id, dataset: e.key as CohortDataset}))
    }

    const menuProps = {
        items: options,
        onClick: handleMenuClick,
    }

    const editable = _.isNil(query.sparkQuery)
    if (editable) {
        const item = options.find(i => i.key.toString() === query.dataset.toString())
        if (item) {
            return <div>
            <span className={styles.label}>Select healthcare dataset(s)
                <Popover content={'Choose the dataset for your cohort'} overlayStyle={{ maxWidth: "600px" }} zIndex={10000} >
                    <InfoCircleTwoTone style={{fontSize: '14px', padding: "0 2px 0 4px"}} twoToneColor="#008ef1"/>
                </Popover>
            </span>
                <Dropdown.Button menu={menuProps} size={'small'} className={styles.dropdown}>
                    {item.icon} {item.label}
                </Dropdown.Button>
            </div>
        } else {
            return <div>No permissions for any healthcare dataset(s)</div>
        }
    } else {
        const item = COHORT_BUILDER_DATASETS.find(i => i.key.toString() === query.dataset.toString())!
        return <div>
            <span className={styles.label}>Healthcare dataset
                <Popover content={'The dataset of this cohort'} overlayStyle={{ maxWidth: "600px" }} zIndex={10000} >
                    <InfoCircleTwoTone style={{fontSize: '14px', padding: "0 2px 0 4px"}} twoToneColor="#008ef1"/>
                </Popover>
            </span>
            <div>{item.icon} {item.label}</div>
        </div>
    }
}